import gql from 'graphql-tag';

/**
 * Project fields the server recomputes when a configuration block saves (pre-save hooks and
 * `Project.registrationChecks`). Selected by the block mutations so the store stays current.
 */
export const PROJECT_CONFIGURATION_RECOMPUTED_FIELDS = gql`
  fragment projectConfigurationRecomputedFields on Project {
    id
    solarPlant {
      solarPanelCount
      solarPlantOverallPower
    }
    calculatedExpectedTimeExpenditureInDays
    netRegistrationRequirementsFullfilledState
    netRegistrationRequirements {
      name
      fullfilledState
    }
    operationRegistrationRequirementsFullfilledState
    operationRegistrationRequirements {
      name
      fullfilledState
    }
  }
`;
